import { selectConfiguration } from '../features/configuration/slice/selectors';
import { useAppSelector } from '../redux/store';

const useConfigurationData = () => {
    const dataConfig = useAppSelector(selectConfiguration);
    return dataConfig;
};

export default useConfigurationData;
